import { Link } from "react-router-dom";

export default function Footer({
  visible = true,
  mode = "normal",
  activated,
  activeSection,  
}) {
  if (!visible || activeSection === "intel") return null;

  const footerClass =
    mode === "home"
      ? `nav-bottom ${activated ? "show-bottom" : ""}`
      : "nav-bottom show-bottom";

  return (
    <footer className={footerClass}>
      <ul className="navbar-nav">
        <li><Link to="/branding" className="nav-link">Branding</Link></li>
        <li><Link to="/ui-ux" className="nav-link">UI/UX</Link></li>
        <li><Link to="/search-visibility-optimisation" className="nav-link">SEO & GEO</Link></li>
        <li><Link to="/marketing" className="nav-link">Marketing</Link></li>
        <li><Link to="/production-post-production" className="nav-link">Production & Post-production</Link></li>
      </ul>
    </footer>
  );
}
